import { clientsListingStore } from '@/app/features/clients/features/clients-listing/clients-listing.store';
import { clientDetailsStore } from '@/app/features/clients/features/client-details/client-details.store';
import { newClientStore } from '@/app/features/clients/features/new-client/new-client.store';
export const clientsStore = {
  modules: {
    clientsListingState: clientsListingStore,
    clientDetailsState: clientDetailsStore,
    newClientState: newClientStore
  }
};
